import api from "./client";

export async function listFasonOrders({ statusGroup = null, page = 1, limit = 50 } = {}) {
  const params = new URLSearchParams();
  if (statusGroup) params.set("status_group", String(statusGroup));
  if (page !== undefined && page !== null) params.set("page", String(page));
  if (limit !== undefined && limit !== null) params.set("limit", String(limit));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.get(`/fason-orders${qs}`);
  return res.data.data;
}

export async function getFasonOrder(id) {
  const res = await api.get(`/fason-orders/${id}`);
  return res.data.data;
}

export async function createFasonOrder(payload) {
  const res = await api.post("/fason-orders", payload);
  return res.data.data;
}

export async function markFasonAtPrinting(id, payload) {
  const res = await api.post(`/fason-orders/${id}/at-printing`, payload);
  return res.data.data;
}

export async function markFasonReceived(id, payload) {
  const res = await api.post(`/fason-orders/${id}/received`, payload);
  return res.data.data;
}

export async function cancelFasonOrder(id) {
  const res = await api.post(`/fason-orders/${id}/cancel`);
  return res.data.data;
}
